import * as qs from "query-string";
import Constant from "../utils/constant";
const handleQuery = () => {
    const result = `&sid=${Constant.sid}&language=${Constant.language}&currency=${Constant.currency}&country=${Constant.country}`;
    return result;
};
function checkStatus(response) {
    if (!response.ok) {
        console.error(response.status, response.statusText);
    }
    return response;
}
const API_UAT = "/litb-header-zeus";
const API_ONLINE = "/litb-header-zeus";
function transformAddress(isOnline) {
    var _a;
    if (isOnline) {
        return `https://${(_a = location.host) === null || _a === void 0 ? void 0 : _a.replace("mpro-pre", "pro")}${API_ONLINE}`;
    }
    if (Constant.isDev) {
        return `http://kdev0.tbox.me${API_UAT}`;
    }
    return API_UAT;
}
function webapi(method, params = {}, { fetchMethod = "GET", headers = {}, onSentryCatch } = {}) {
    var _a, _b;
    const isOnline = !Constant.isUat;
    const platform = Constant.platform.toLocaleLowerCase();
    const webapiAddress = transformAddress(isOnline);
    if (Constant.isUat) {
        params = Object.assign(Object.assign({}, params), { isUat: Constant.isUat });
    }
    const addQuery = handleQuery();
    const url = `${webapiAddress}/${platform}/${method}?${qs.stringify(params)}${addQuery}`;
    if (!!isOnline) {
        headers = Object.assign(Object.assign({}, headers), { host: "api.lightinthebox.com" });
    }
    const isPre = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.includes("-pre");
    return fetch(url, {
        mode: "cors",
        method: fetchMethod,
        credentials: Constant.isDev || isPre ? "same-origin" : "include",
        headers
    })
        .then(checkStatus)
        .then(response => {
        if (response) {
            return response.json();
        }
    })
        .catch(error => {
        onSentryCatch &&
            onSentryCatch({
                error,
                request: url
            });
        throw error;
    });
}
export default webapi;
